/**
 * @generated SignedSource<<d3ba0c6df1b36a061244ff666e15e424>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type assetLibraryQueriesUpdateAIAssetLibraryCategoryMutation$variables = {
  id: string;
  name: string;
  sortOrder: number;
};
export type assetLibraryQueriesUpdateAIAssetLibraryCategoryMutation$data = {
  readonly updateAIAssetLibraryCategory: {
    readonly createdDate: string;
    readonly id: string;
    readonly modifiedDate: string;
    readonly name: string;
    readonly sortOrder: number;
  };
};
export type assetLibraryQueriesUpdateAIAssetLibraryCategoryMutation = {
  response: assetLibraryQueriesUpdateAIAssetLibraryCategoryMutation$data;
  variables: assetLibraryQueriesUpdateAIAssetLibraryCategoryMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "name"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "sortOrder"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "name"
      },
      {
        "kind": "Variable",
        "name": "sortOrder",
        "variableName": "sortOrder"
      }
    ],
    "concreteType": "AIAssetLibraryCategoryDTO",
    "kind": "LinkedField",
    "name": "updateAIAssetLibraryCategory",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sortOrder",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdDate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "modifiedDate",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "assetLibraryQueriesUpdateAIAssetLibraryCategoryMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "assetLibraryQueriesUpdateAIAssetLibraryCategoryMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "44b9668ac65679f5689e7529dd32294d",
    "id": null,
    "metadata": {},
    "name": "assetLibraryQueriesUpdateAIAssetLibraryCategoryMutation",
    "operationKind": "mutation",
    "text": "mutation assetLibraryQueriesUpdateAIAssetLibraryCategoryMutation(\n  $id: ID!\n  $name: String!\n  $sortOrder: Int!\n) {\n  updateAIAssetLibraryCategory(id: $id, name: $name, sortOrder: $sortOrder) {\n    id\n    name\n    sortOrder\n    createdDate\n    modifiedDate\n  }\n}\n"
  }
};
})();

(node as any).hash = "00f2de0dc764d08192fd9fa08ade5b5f";

export default node;
